export const GIG_TYPES = {
    RECURRING: 'gig_recurring',
};
